import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class Lines {
	static init() {
		let blocks = document.querySelectorAll('.h-line, .v-line');
		blocks.forEach( (block) => {
			ScrollTrigger.create({
				trigger: block,
				start: 'top 95%',
				once: true,
				toggleClass: 'enable'
			});
		});
	}
}
